import { GridColDef } from "@mui/x-data-grid-pro"
import { FnAxios, FnDialog, I18n } from "utilities/utilities";
import { BtnAddOnTableRender, BtnEditOnTableRender, DefaultParamCol } from "../Ticket/components/CreateColumnTable";
import { useEffect, useState } from "react";
import { PaginationInterface, initRows } from 'components/DataGrid';
import { useForm } from "react-hook-form";
import { I18NextNs } from "enum/enum";
import moment from "moment";
import { numberFormatterLocale, renderCellUpdate } from "../Ticket/fnTickit";
import { GetMenuPermissionParamRoute } from "utilities/SystemFunction";

export function useFundIncomeActual() {

    const AxiosFn = FnAxios();
    const DialogFn = FnDialog();

    const [isPermission, setIsPermission] = useState<boolean>(false);
    const [nPrmUser, setNPrmUser] = useState(2);
    const [anchorEl, setAnchorEl] = useState(null);
    const [messagePopper, setMessagePopper] = useState("")
    const [loadingTable, setLoadingTable] = useState(false);
    const [dataRow, setDataRow] = useState<PaginationInterface>({
        ...initRows,
        sSortExpression: "sUpdate",
        sSortDirection: "desc",
    });


    //#region Form
    const formSearch = useForm({
        shouldUnregister: false,
        shouldFocusError: true,
        mode: "all",
    });
    // #endregion

    useEffect(() => {
        GetMenuPermissionParamRoute("/FundIncomeActualList", AxiosFn, setIsPermission, DialogFn);
        getTable(dataRow);
    }, [])


    const getTable = (p: PaginationInterface) => {
        DialogFn.BlockUI();
            DialogFn.UnBlockUI();

        setLoadingTable(true);
        let Param = {
            ...p,
            arrRows: [],
            nDate: formSearch.getValues("dDate") ? moment(formSearch.getValues("dDate")).valueOf() : null,
        };
        AxiosFn.Post(`FundIncomeActual/GetTableFundIncomeActual`, Param, (result) => {
            setLoadingTable(false);
            DialogFn.UnBlockUI();
            let objResult = result.objResult;
            setDataRow({
                ...p,
                arrRows: objResult.lstData,
                nDataLength: objResult.nDataLength,
                nPageIndex: objResult.nPageIndex,
            });
        });
    };
    const onDelete = (arrSelect) => {
        DialogFn.Submit(I18n.SetText("Message.ConfirmDelete", I18NextNs.labelComponent), () => {
            DialogFn.BlockUI();
            setLoadingTable(true);
            AxiosFn.Post(`FundIncomeActual/OnDeleteTableFundIncomeActual`, { lstId: arrSelect }, () => {
                DialogFn.UnBlockUI();
                DialogFn.Success(I18n.SetText("Message.DeleteComplete", I18NextNs.labelComponent));
                getTable(dataRow)
            });
        });
    }

    const handleClearSearch = () => {
        Object.keys(formSearch.getValues()).forEach((key => {
            formSearch.setValue(key, null);
            formSearch.clearErrors(key);
        }))
        getTable(dataRow);
    };


    const dataColumn: GridColDef[] = [
        {
            ...DefaultParamCol,
            field: "cAction",
            width: 60,
            minWidth: 60,
            headerName: "",
            sortable: false,
            type: "actions",
            flex: 0,
            renderHeader: () => {
                if (isPermission && nPrmUser === 2) {
                    return (
                        <BtnAddOnTableRender
                            path={"/FundIncomeActualForm"}
                            nPermision={nPrmUser}
                        />
                    );
                }
            },
            renderCell: (params) => {
                return (
                    <BtnEditOnTableRender
                        path={"/FundIncomeActualForm"}
                        params={params}
                        nPermision={isPermission ? params.row.isView ? 1 : 2 : 1}
                    />
                );
            },
        },
        {
            ...DefaultParamCol,
            field: "sDateIncome",
            headerName: `ประจำเดือน ปี`,
        },
        {
            ...DefaultParamCol,
            field: "nTrade",
            headerName: `ค่าธรรมเนียมค้าซากฯ`,
            align: "right",
            flex: 1.5,
            renderCell: (params) => {
                return (
                    <>
                        {numberFormatterLocale(params.value, 2)}
                    </>
                );
            },
        },
        {
            ...DefaultParamCol,
            field: "nInterest",
            headerName: `ดอกเบี้ย`,
            align: "right",
            flex: 1.5,
            renderCell: (params) => {
                return (
                    <>
                        {numberFormatterLocale(params.value, 2)}
                    </>
                );
            },
        },
        {
            ...DefaultParamCol,
            field: "nDonate",
            headerName: `เงินบริจาค`,
            align: "right",
            flex: 1.5,
            renderCell: (params) => {
                return (
                    <>
                        {numberFormatterLocale(params.value, 2)}
                    </>
                );
            },
        },
        {
            ...DefaultParamCol,
            field: "nOther",
            headerName: `อื่นๆ`,
            align: "right",
            flex: 1.5,
            renderCell: (params) => {
                return (
                    <>
                        {numberFormatterLocale(params.value, 2)}
                    </>
                );
            },
        },
        {
            ...DefaultParamCol,
            field: "nTotal",
            headerName: `ยอดรวม`,
            align: "right",
            flex: 1.5,
            renderCell: (params) => {
                return (
                    <>
                        {numberFormatterLocale(params.value, 2)}
                    </>
                );
            },
        },
        // {
        //     ...DefaultParamCol,
        //     field: "sUpdateName",
        //     headerName: `แก้ไขโดย`,
        //     align: "left",
        //     flex: 2,
        // },
        {
            ...DefaultParamCol,
            field: "sUpdate",
            headerName: `วันที่แก้ไขล่าสุด`,
            flex: 1.5,
            renderCell: (params) => {
                return (
                    <>
                        {renderCellUpdate(params, handleClickUpdate)}
                    </>
                )
            }
        }
    ];

    const handleClickUpdate = (event, params) => {
        setAnchorEl(event.currentTarget);
        setMessagePopper(params.row.sUpdateName)
    };


    return {
        isPermission,
        dataColumn,
        getTable,
        onDelete,
        dataRow,
        loadingTable,
        formSearch,
        nPrmUser,
        handleClearSearch,
        anchorEl,
        setAnchorEl,
        messagePopper,
    };
}
